import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/push')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/engagement' });
  },
  component: () => null,
});
